import { useContext } from 'react';

import { I18nContext, type I18nContextValue } from './I18nContext';

export function useTranslation(): I18nContextValue {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error('useTranslation deve ser usado dentro de <I18nProvider>.');
  }
  return ctx;
}
